import moment from 'moment';

export const MESSAGE_FROM = {
  client: 'message-from-client',
  agent: 'message-from-agent',
  system: 'message-from-system',
};

export const MESSAGE_TYPE = {
  text: 'message/type/text',
  interactiveSurvey: {
    ask: 'message/type/interactive-survey/ask',
    additionalData: 'message/type/interactive-survey/additional-data',
    end: 'message/type/interactive-survey/end',
  },
  image: 'message/type/image',
  file: 'message/type/file'
};

export const systemMessage = props => ({
  from: MESSAGE_FROM.system,
  type: MESSAGE_TYPE.text,
  name: '',
  sent: moment(),
  ...props,
});

export const imageMessage = image => ({
  from: MESSAGE_FROM.agent,
  type: MESSAGE_TYPE.image,
  sent: moment(),
  content: image,
});

export const fileMessage = (guid, fileName) => ({
  from: MESSAGE_FROM.agent,
  type: MESSAGE_TYPE.file,
  sent: moment(),
  content: { guid, fileName }
});

export const surveyAdditionalDataMessage = (additionalData, props) => systemMessage({
  additionalData,
  type: MESSAGE_TYPE.interactiveSurvey.additionalData,
  content: additionalData.labelQuestion,
  bsStyle: 'agent',
});

export const messageFromTPClientAPI = message => ({
  from: message.chatPart === 'A' ? MESSAGE_FROM.agent : (
    message.chatPart === 'U' ? MESSAGE_FROM.client : MESSAGE_FROM.system
  ),
  type: MESSAGE_TYPE.text,
  name: message.chatPartName,
  content: message.chatText,
  sent: moment(message.chatTextDate)
});



// WEBPACK FOOTER //
// ./reducers/chat/message.js